import { useQuery } from "@tanstack/react-query"
import { Timelapse } from "../types/timelapse"
import { apiGet } from "./query"
import { STALE_TIME } from "../types/staleTime"
import { convertScans } from "../types/scan"

const ENDPOINT = "scan"

export const useScanGetByTimelapse = ({ id }: Pick<Timelapse, "id">) => {
  return useQuery({
    queryKey: ["scan", "timelapse", id],
    queryFn: async () => (await apiGet(`${ENDPOINT}/timelapse/${id}`, convertScans)).data,
    staleTime: STALE_TIME.MIN_5,
    throwOnError: true,
    enabled: id > 0,
  })
}

export const useScanGetLast20 = () => {
  return useQuery({
    queryKey: ["scan", "last"],
    queryFn: async () => (await apiGet(`${ENDPOINT}/last`, convertScans)).data,
    staleTime: STALE_TIME.MIN_5,
    throwOnError: true,
  })
}
